import { HttpTransportType, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import * as Constants from "config";
import Guid from "_shared/guids/guid";
import { getSignalRReconnectDelaysMs } from "_shared/_stores/realtime/signalr-reconnect-policy";
import NotificationSchema from "notifications/entities/notification/notification-schema";
import {
  addNotification,
  removeNotification,
} from "notifications/entities/notification/store/notifications-redux-slice";
import Session from "users/__session/session";
import Notification from "notifications/entities/notification/notification";
import MessageNotification from "notifications/entities/message-notification/message-notification";
import MessageNotificationSchema from "notifications/entities/message-notification/message-notification-schema";
import reduxSignalRMiddleware, { withCallbacks } from "_shared/_stores/realtime/redux-signalr-middleware";

export const notificationsHubConnection = new HubConnectionBuilder()
  .configureLogging(LogLevel.Debug)
  .withUrl(`${Constants.apiBaseUrl}/notificationHub`, {
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () => Session.loadFromStorage(() => {}).authToken?.value ?? "",
  })
  .withAutomaticReconnect(getSignalRReconnectDelaysMs())
  .build();

const toNotification = (payload: unknown): Notification | MessageNotification | undefined => {
  // Try the more specific schema first
  if (MessageNotificationSchema.isValidJSON(payload)) {
    return MessageNotification.fromJSON(payload);
  }

  if (NotificationSchema.isValidJSON(payload)) {
    return Notification.fromJSON(payload);
  }

  return undefined;
};

const callbacks = withCallbacks()
  .add("notification-received", (payload: unknown) => (dispatch) => {
    const notification = toNotification(payload);
    if (notification) {
      dispatch(addNotification(notification));
    }
  })
  .add("notification-updated", (payload: unknown) => (dispatch) => {
    const notification = toNotification(payload);
    if (notification) {
      dispatch(addNotification(notification));
    }
  })
  .add("notification-deleted", (payload: unknown) => (dispatch) => {
    const deletedNotificationId = new Guid((payload as { id: string }).id);
    dispatch(removeNotification(deletedNotificationId));
  });

export const notificationsSignalRReduxMiddleware = reduxSignalRMiddleware({
  callbacks,
  connection: notificationsHubConnection,
  connectionHealth: { key: "notifications", label: "Notifications" },
  shouldConnectionStartImmediately: true,
});
